<template>
  <v-dialog v-model="isShow" persistent width="800">
      <v-overlay :value="isLoading">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <CalendarViewModal
      :isShow="isPreviewShow"
      @close="isPreviewShow = false"
      :calendar="mergedCalendar"
    ></CalendarViewModal>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close">mdi-close</v-icon>
      </v-toolbar>
      <v-card-text class="mt-5">
        <v-row>
          <v-col cols="12" style="padding: 0px">
            <!--<v-autocomplete
              label="Select Calendar(s)"
              :items="calendars"
              v-model="selectedItems"
              item-text="name"
              item-value="identity"
              multiple
            ></v-autocomplete> -->

          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="2" md="2" sm="2" style="padding: 0px">
            <v-checkbox label="Select Period" v-model="hasPeriod"></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="4"
            style="padding: 0px"
            v-show="hasPeriod"
          >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="start"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="4"
            style="padding: 0px 20px"
            v-show="hasPeriod"
          >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="end"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="end"
                @input="menu2 = false"
                :min="start"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="3" md="3" sm="3" style="padding: 0px">
            <v-select
              label="Type"
              :items="types"
              v-model="type"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="preview()" outlined class="mr-2"
          >Preview</v-btn
        >
        <v-btn color="primary" @click="download()">Download</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import CalendarViewModal from "./CalendarViewModal.vue";
import {calService} from '@/api/cal-service';

export default {
  name: "CalendarDownloadModal",
  props: { isShow: Boolean, calendar: Object, calendars: Array },
  components: { CalendarViewModal },
  data: () => {
    return {
      title: "",
      selectedItems: [],
      hasPeriod: false,
      types: ["Excel", "PDF", "PNG"],
      type: "Excel",
      start: "",
      end: "",
      menu1: false,
      menu2: false,
      isPreviewShow: false,
      mergedCalendar: { name: "", events: [] },
      isLoading:false
    };
  },
  methods: {
    close() {
      this.selectedItems = [];
      this.$emit("close", "close");
    },
    preview() {
      let _merged = { name: "Preview Calendar", events: [] };
      
      this.calendar.events.forEach(e => {
         if (this.inPeriod(e)) {
            _merged.events.push(e);
          }
      });
    
      this.mergedCalendar = _merged;
      this.isPreviewShow = true;
    },
    async download() {
      //console.log(this.selectedItems);
      //console.log(this.start + " " + this.end);
      this.isLoading = true;
      let _merged = { name: "Preview Calendar", events: [] };
      
      this.calendar.events.forEach(e => {
         if (this.inPeriod(e)) {
            _merged.events.push(e);
          }
      });

      _merged.name = this.calendar.name;
      this.mergedCalendar = _merged;

       this.isLoading = true;
        var result = await calService.generateExcel(this.mergedCalendar, this.type)
        this.isLoading = false;
        //await calService.downloadExcel(result)
        let _url = process.env.VUE_APP_HOST +
          "api/calendar/download/"+result

        if (this.type !== 'Excel')
          _url = _url + '?type=' + this.type

        window.location = _url 
        this.isLoading = false;
    },
    inPeriod(e){
        if (!this.hasPeriod) return true;
        if (moment(e.startDateTime).isAfter(moment(this.start).add(-1,'minutes'))&&moment(e.startDateTime).isBefore(moment(this.end).add(1,'day'))) return true;
        return false;
    }
  },
  watch: {
    calendar: {
      handler() {
        if (this.calendar.name) {
         this.title = 'Download '+this.calendar.name.replace('#','&')
         // this.selectedItems = [];
         // this.title = "Download " + this.calendar.name;
         //  this.selectedItems.push(this.calendar.identity);
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>